
const dimens = {
    campo: 26,
    fonte_campo: 15,
    rotulo: 26,
    fonte_rotulo: 15,
    fonte_rotulo_menor: 11,
    fonte_maior: 16,
  };
  

export default dimens;